import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getGlobalModal } from '../../redux/reducers/GlobalModalReducer';
import { hideModal } from '../../redux/actions/GlobalModalActions';

class ModalContainer extends Component {
  state = {
    options: {},
    modalComponent: null,
    hidingModal: false,
  };

  componentWillReceiveProps(nextProps) {
    const { modalComponent: currentModal } = this.state;
    if (currentModal && !nextProps.modalComponent) {
      // This means a modal has been removed
      setTimeout(() => {
        this.setState({ modalComponent: null, hidingModal: false, options: {} });
      }, 1000);
      this.setState({ hidingModal: true });
    } else {
      this.setState({ ...nextProps, hidingModal: false });
    }
  }

  closeModal = () => {
    const { hideModal } = this.props;
    hideModal();
  };

  render() {
    const { options, modalComponent: ModalComponent, hidingModal } = this.state;

    if (!ModalComponent) {
      return null;
    }
    options.className += ` ${hidingModal ? 'hiding' : 'normal'}`;

    return <ModalComponent onClose={this.closeModal} {...options} />;
  }
}

const mapStateToProps = (state) => {
  return {
    ...getGlobalModal(state),
  };
};

const mapDispatchToProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
